import React, { ReactNode } from 'react';

import styled from '@emotion/styled';
import { NavLink } from 'react-router-dom';

import { Icon, IconSize } from '@britishcouncil/react-solas';

type IconLinkProps = {
  to: string;
  size?: IconSize;
  extraContent?: ReactNode;
  icon: JSX.Element;
  sticked?: boolean;
};

const IconLink = ({ size = 'tiny', to, extraContent, icon, sticked }: IconLinkProps) => (
  <li>
    <StyledLink to={to}>
      <IconComponent link fitted size={size}>
        {icon}
      </IconComponent>
      {extraContent && <ExtraContent>{extraContent}</ExtraContent>}
    </StyledLink>
    {sticked && (
      <StickedLink to={to}>
        <IconComponent link fitted size={size}>
          {icon}
        </IconComponent>
        {extraContent && <ExtraContent>{extraContent}</ExtraContent>}
      </StickedLink>
    )}
  </li>
);

const ExtraContent = styled.span`
  margin-left: 4px;
`;

const IconComponent = styled(Icon)`
  margin-top: 1px;
  margin-bottom: -1px;
`;

const StyledLink = styled(NavLink)`
  svg {
    fill: var(--bc-sui-header-btn-primary-color);
  }

  &.active svg {
    fill: var(--bc-sui-header-btn-primary-hover-color);
  }

  &:hover svg {
    fill: var(--bc-sui-header-btn-primary-hover-color);
  }

  ul.nav > li > & {
    display: flex;
  }
`;

const StickedLink = styled(StyledLink)`
  ul.nav > li > & {
    display: none;

    @media (min-width: 850px) {
      display: block;
      position: fixed;
      top: 0;
      margin-top: -3px; //[GP]: work around for Solas custom header margin props...
      z-index: 100;
    }
  }
`;

export default IconLink;
